const STORAGE_KEYS = {
  sessionToken: 'orchestratorPlayerSessionToken',
  diceState: 'orchestratorPlayerDiceState',
};

import { buildDualityCommand } from '../../features/orchestrator/utils/dualityModes';

const resolveDieIcon = (text, fallback = 'duality') => {
  const lowered = String(text || '').toLowerCase();
  if (lowered.includes('duality')) return 'duality';

  const match = lowered.match(/d(?:100|20|12|10|8|6|4)/);

  if (!match) return fallback;

  switch (match[0]) {
    case 'd4':
      return 'd4';
    case 'd6':
      return 'd6';
    case 'd8':
      return 'd8';
    case 'd10':
    case 'd100':
      return 'd10';
    case 'd12':
      return 'd12';
    case 'd20':
      return 'd20';
    default:
      return fallback;
  }
};

export { STORAGE_KEYS, buildDualityCommand, resolveDieIcon };
